<div class="main">
  <div class="side-menu" [ngClass]="{ 'is-open': isMenuOpen }">
    <div class="side-menu-wrapper">
      <img src="../../assets/images/logo-2.svg" alt="" />
      <button style="font-size: 20px;" class="close-menu-btn" (click)="toggleMenu()">&times;</button>
      <div class="side-menu-inner pt-5">
        <div class="nav flex-column nav-pills me-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
          <button class="nav-link hover-button" [ngClass]="{ active: activeFeature === 'orders' }" 
            id="v-pills-orders-tab" data-bs-toggle="pill" data-bs-target="#v-pills-orders" 
            type="button" role="tab" aria-controls="v-pills-orders" aria-selected="false" 
            *ngIf="availableFeatures.includes('orders') || isOrdersAdmin" (click)="setActiveFeature('orders')">
            <img src="../../assets/images/confetti.svg" alt="" />
            Birthdays
          </button>
          <button class="nav-link hover-button" [ngClass]="{ active: activeFeature === 'notifications' }" 
            id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile" 
            type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false" 
            *ngIf="availableFeatures.includes('notifications')" (click)="setActiveFeature('notifications')">
            <img src="../../assets/images/notification.svg" alt="" />
            Notifications
          </button>
          <button class="nav-link hover-button" [ngClass]="{ active: activeFeature === 'analytics' }" 
            id="v-pills-analytics-tab" data-bs-toggle="pill" data-bs-target="#v-pills-analytics" 
            type="button" role="tab" aria-controls="v-pills-analytics" aria-selected="false" 
            *ngIf="availableFeatures.includes('analytics')" (click)="setActiveFeature('analytics')">
            <img src="../../assets/images/analytics.svg" alt="" /> Analytics
          </button>
          <button class="nav-link hover-button" [ngClass]="{ active: activeFeature === 'analyticsDummy' }" 
            id="v-pills-analytics-dummy-tab" data-bs-toggle="pill" data-bs-target="#v-pills-analytics-dummy" 
            type="button" role="tab" aria-controls="v-pills-analytics-dummy" aria-selected="false" 
            *ngIf="availableFeatures.includes('analyticsDummy')" (click)="setActiveFeature('analyticsDummy')">
            <img src="../../assets/images/analytics.svg" alt="" /> Analytics
          </button>
          <button class="nav-link hover-button" [ngClass]="{ active: activeFeature === 'feed' }" 
            id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home" 
            type="button" role="tab" aria-controls="v-pills-home" aria-selected="false" 
            *ngIf="availableFeatures.includes('feed')" (click)="setActiveFeature('feed')">
            <img src="../../assets/images/feed.svg" alt="" /> My Feed
          </button>
          <button class="nav-link hover-button" [ngClass]="{ active: activeFeature === 'vouchers' }" 
            id="v-pills-gift-tab" data-bs-toggle="pill" data-bs-target="#v-pills-gift" 
            type="button" role="tab" aria-controls="v-pills-gift" aria-selected="false" 
            *ngIf="availableFeatures.includes('vouchers')" (click)="setActiveFeature('vouchers'); loadGiftCards()">
            <img src="../../assets/images/gift.svg" alt="" />
            Vouchers
          </button>
        </div>
        <div>
          <!-- <app-csv
            *ngIf="availableFeatures.includes('dataExtraction')"
            [businessId]="businessId"
          ></app-csv> -->
          <button *ngIf="isSuperAdmin || isOrdersAdmin" class="switch-playground-btn hover-button" (click)="openPlaygroundSwitcher()">
            <img src="../../assets/images/switch.svg" alt="" /> Switch Playground
          </button>
          <hr *ngIf="isSuperAdmin || isOrdersAdmin" />
          <button class="bg-transparent border-0 px-0 hover-button" (click)="logout()">
            <img src="../../assets/images/logout.svg" alt="" /> Log out
          </button>
          <div class="side-m-bottom">
            <img src="../../assets/images/logo-sailor.svg" alt="" />
            <p>
              © 2025 Gulli Magnets. <br />
              All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="content">
    <button class="hamburger-menu" (click)="toggleMenu()">
      <div class="hamburger-menu-line"></div>
      <div class="hamburger-menu-line"></div>
      <div class="hamburger-menu-line"></div>
    </button>
    <div class="tab-content h-100" id="v-pills-tabContent">
      <div class="tab-pane fade" [ngClass]="{ 'show active': activeFeature === 'orders' }" 
        id="v-pills-orders" role="tabpanel" aria-labelledby="v-pills-orders-tab" 
        *ngIf="availableFeatures.includes('orders') || isOrdersAdmin">
        <h1>Birthdays</h1>
        <app-orders-admin *ngIf="isOrdersAdmin" [businessId]="businessId"></app-orders-admin>
        <app-orders *ngIf="!isOrdersAdmin" [businessId]="businessId"></app-orders>
      </div>
      <div class="tab-pane fade" [ngClass]="{ 'show active': activeFeature === 'notifications' }" 
        id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab" 
        *ngIf="availableFeatures.includes('notifications')">
        <h1>Notifications</h1>
        <app-notifications [businessData]="businessData"></app-notifications>
      </div>
      <div class="tab-pane fade" [ngClass]="{ 'show active': activeFeature === 'analytics' }" 
        id="v-pills-analytics" role="tabpanel" aria-labelledby="v-pills-analytics-tab" 
        *ngIf="availableFeatures.includes('analytics')">
        <h1>Analytics</h1>
        <app-analytics [businessId]="businessId"></app-analytics>
      </div>
      <div class="tab-pane fade" [ngClass]="{ 'show active': activeFeature === 'analyticsDummy' }" 
        id="v-pills-analytics-dummy" role="tabpanel" aria-labelledby="v-pills-analytics-dummy-tab" 
        *ngIf="availableFeatures.includes('analyticsDummy')">
        <h1>Analytics</h1>
        <app-analytics-dummy-data></app-analytics-dummy-data>
      </div>
      <div class="tab-pane fade" [ngClass]="{ 'show active': activeFeature === 'feed' }" 
        id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab" 
        *ngIf="availableFeatures.includes('feed')">
        <h1>My feed</h1>
        <app-feed [businessData]="businessData"></app-feed>
      </div>
      <div class="tab-pane fade" [ngClass]="{ 'show active': activeFeature === 'vouchers' }" 
        id="v-pills-gift" role="tabpanel" aria-labelledby="v-pills-gift-tab" 
        *ngIf="availableFeatures.includes('vouchers')">
        <h1>Vouchers</h1>
        <div *ngIf="loading">Loading vouchers...</div>
        <div *ngIf="!loading">
          <app-gift-cards (giftCardAdded)="loadGiftCards()" (newTab)="checkTabStatus($event)" [giftCards]="giftCards"
            [activeTabFromParent]="activeTab" [hasBirthdayCards]="hasBirthdayCards"
            [hasExtraGameCards]="hasExtraGameCards" [hasOtherCards]="hasOtherCards" [businessId]="businessId"
            [activationCode]="activationCode"></app-gift-cards>
        </div>
      </div>


      <div class="business-name">
        <h2>{{ isOrdersAdmin && allPlaygroundsSelected ? 'All Playgrounds' : businessData.name }}</h2>
        <img *ngIf="!isOrdersAdmin" [src]="businessData.businessImageUrl" alt="" />
      </div>
    </div>
  </div>

  <!-- Playground Switcher Overlay -->
  <div *ngIf="showSwitcher && (isSuperAdmin || isOrdersAdmin)" class="playgrounds-overlay" (click)="closePlaygroundSwitcher()">
    <div class="playgrounds-wrapper" (click)="$event.stopPropagation()">
      <header class="playgrounds-header">
        <h2 class="playgrounds-title">Switch playground</h2>
        <button type="button" class="playgrounds-close" (click)="closePlaygroundSwitcher()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </header>
      <div class="playgrounds-actions" *ngIf="isOrdersAdmin && playgrounds?.length > 1">
        <button type="button" class="playgrounds-reset-btn" (click)="resetToAllPlaygrounds()">
          Reset to all playgrounds
        </button>
      </div>
      <div class="playgrounds-search-wrap">
        <input
          type="text"
          class="playgrounds-search"
          placeholder="Search playgrounds…"
          (input)="searchPlaygrounds($event)"
        />
      </div>
      <div class="playgrounds-grid">
        <button
          *ngFor="let playground of filteredPlaygrounds"
          type="button"
          class="playground-card"
          [class.playground-card-no-image]="isOrdersAdmin"
          (click)="switchPlayground(playground)"
        >
          <span class="playground-card-image" *ngIf="!isOrdersAdmin">
            <img [src]="playground.businessImageUrl" [alt]="playground.name" />
          </span>
          <span class="playground-card-placeholder" *ngIf="isOrdersAdmin">
            <img src="../../assets/images/confetti.svg" alt="" class="playground-card-icon" />
          </span>
          <span class="playground-card-name">{{ playground.name }}</span>
        </button>
      </div>
      <p *ngIf="filteredPlaygrounds.length === 0" class="playgrounds-empty">No playgrounds match your search.</p>
    </div>
  </div>
</div>